import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { Eye, FileText, Notebook, CardsThree } from '@phosphor-icons/react'
import PropTypes from 'prop-types'

const iconMap = {
   package: Notebook,
   report: FileText,
   resources: CardsThree
}

const MarketplaceItemAlt = ({ icon, number, subtitle, title }) => {
   const Icon = iconMap[icon]

   return (
      <div
         className={classNames(
            'flex items-center gap-4 p-4 bg-emerald-100/20 text-emerald-100 border border-solid border-emerald-100/20 rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)]'
         )}>
         <div className="flex-0 flex justify-center items-center w-16 h-16 rounded-lg bg-white/10">
            <Icon size="32" />
         </div>
         <div className="flex-1">
            <div className="font-semibold">{title}</div>
            <div className="text-xs opacity-70">{subtitle}</div>
            <div className="flex items-center gap-2 text-xs opacity-50 pt-1">
               <Eye size="12" />
               {number}
            </div>
         </div>
         <div className="flex-0">
            <div className="inline text-xs font-semibold bg-emerald-100/10 text-emerald-100  px-4 py-2 rounded-full">Download</div>
         </div>
      </div>
   )
}
MarketplaceItemAlt.propTypes = {
   icon: PropTypes.string.isRequired,
   number: PropTypes.string.isRequired,
   subtitle: PropTypes.string.isRequired,
   title: PropTypes.string.isRequired
}

const MarketplaceItem = ({ icon, number, subtitle, title }) => {
   const Icon = iconMap[icon]

   return (
      <div
         className={classNames(
            'flex items-center gap-4 p-4 bg-white text-black rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)]'
         )}>
         <div className="flex-0 flex justify-center items-center w-14 h-14 rounded-lg bg-neutral-200">
            <Icon size="32" />
         </div>
         <div className="flex-1">
            <div className="font-semibold">{title}</div>
            <div className="text-xs opacity-70">{subtitle}</div>
            <div className="flex items-center gap-2 text-xs opacity-50 pt-1">
               <Eye size="12" />
               {number}
            </div>
         </div>
         <div className="flex-0">
            <div className="inline text-xs font-semibold bg-neutral-200 px-4 py-2 rounded-full">Download</div>
         </div>
      </div>
   )
}
MarketplaceItem.propTypes = {
   icon: PropTypes.string.isRequired,
   number: PropTypes.string.isRequired,
   subtitle: PropTypes.string.isRequired,
   title: PropTypes.string.isRequired
}

const MarkeptlaceFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute flex flex-col gap-4 top-[50%] left-[0%] sm:left-[12%] w-[100%] sm:w-[76%] transition-all duration-700 scale-[70%] sm:scale-100',
               visible ? '-translate-y-[50%]' : '-translate-y-[40%]'
            )}>
            <div
               className={classNames(
                  'transition-all duration-700',
                  visible ? 'opacity-100' : 'opacity-0'
               )}>
               <MarketplaceItemAlt
                  icon="report"
                  number="47,260"
                  subtitle="Last updated a week ago"
                  title="Annual Report"
               />
            </div>
            <div
               className={classNames(
                  'bg-white rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-50',
                  visible ? 'translate-y-0 opacity-90' : 'translate-y-10 opacity-0'
               )}>
               <MarketplaceItem
                  icon="package"
                  number="11,682"
                  subtitle="Last updated Today"
                  title="New Member Package"
               />
            </div>
            <div
               className={classNames(
                  'bg-white rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-100',
                  visible ? 'translate-y-0 opacity-50' : 'translate-y-10 opacity-0'
               )}>
               <MarketplaceItem
                  icon="resources"
                  number="156,441"
                  subtitle="Last updated 2 days ago"
                  title="Sponsorship Resources"
               />
            </div>
         </div>
      </div>
   )
}

MarkeptlaceFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default MarkeptlaceFeature
